const get12HourTimeFormat = (time) => {
  if (typeof time !== "string" || time.split(":").length !== 2) {
    return "";
  }
  const [hours, minutes] = time.split(":");
  if (Number.isNaN(Number(hours)) || Number.isNaN(Number(minutes)) || !hours.trim() || !minutes.trim() || Number(hours) < 0 || Number(hours) > 23 || Number(minutes) < 0 || Number(minutes) > 59) {
    return "";
  }
  const amOrPm = Number(hours) >= 12 ? "pm" : "am";
  const formattedHours = Number(hours) % 12 || 12;
  return `${formattedHours}:${minutes} ${amOrPm}`;
};
var get12HourTimeFormat_default = get12HourTimeFormat;
export {
  get12HourTimeFormat_default as default
};
